module.exports = __webpack_public_path__ + "img/test3.8141e6e0.png";